interface CreateFileParams {
    filename: string
    filetype: string
    data: any,
}

//'application/pdf'

export const createFile = (params: CreateFileParams) => {
    const blob = new Blob([params.data], { type: params.filetype })
    if (window.navigator['msSaveOrOpenBlob']) {
        window.navigator['msSaveBlob'](blob, params.filename)
    }
    else {
        const elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = params.filename
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
        window.URL.revokeObjectURL(elem.href)
    }
}

export const downloadFile = (url: string, name = 'fichier.txt') => {
    
    const hidden_a = document.createElement('a');
    
    hidden_a.setAttribute('href', url);
    
    hidden_a.setAttribute('download', name);
    document.body.appendChild(hidden_a);
    
    hidden_a.click();
    document.body.removeChild(hidden_a);
}

declare global {
    interface Navigator {
        msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void
        msSaveBlob: (blobOrBase64: Blob | string, filename: string) => void
    }
  }